import React from "react";
var __jsx = React.createElement;
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { PublishBadge } from 'components/common/material-ui/custom-components/PublishBadge.style';
import { getPageMetaData } from 'redux/content';
import { CTAButton, CTAContainer, CTAText, CTATextInfo } from '../common/style';
import { PublishIcon, ScheduledOn } from './PublishButton.style';

var PublishButton = function PublishButton(_ref) {
  var onClick = _ref.onClick,
      publicationStatus = _ref.publicationStatus,
      scheduledPublicationDate = _ref.scheduledPublicationDate;
  var intl = useIntl();

  var _useSelector = useSelector(getPageMetaData),
      pageMetaData = _useSelector.value;

  var button = __jsx(CTAButton, {
    "aria-label": intl.formatMessage({
      id: 'content.edit.call-to-actions.publish'
    })
  }, __jsx(PublishIcon, null));

  var badgedButton = pageMetaData === undefined ? button : __jsx(PublishBadge, {
    variant: "dot",
    overlap: "circle",
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    publicationStatus: publicationStatus
  }, button);
  return __jsx(CTAContainer, {
    onClick: onClick
  }, badgedButton, __jsx(FormattedMessage, {
    tagName: CTAText,
    id: 'content.edit.call-to-actions.publish'
  }), scheduledPublicationDate !== undefined && __jsx(CTATextInfo, null, __jsx(FormattedMessage, {
    tagName: "span",
    id: 'date.scheduled-on'
  }), __jsx(ScheduledOn, null, __jsx(FormattedMessage, {
    id: 'date.scheduled-on-date',
    values: {
      date: "".concat(scheduledPublicationDate.toLocaleDateString(), " ").concat(scheduledPublicationDate === null || scheduledPublicationDate === void 0 ? void 0 : scheduledPublicationDate.toLocaleTimeString())
    }
  }))));
};

export default PublishButton;